(($) => {
  Drupal.behaviors.mobileProductsFilter = {
    attach() {
      $('.show-product-filter')
        .once('filter-toggle')
        .on('click', function showFilterClick() {
          $('.close-product-filter').removeClass('is-hide');
          $('.show-product-filter').addClass('is-hide');
          $('.modal').removeClass('is-hide');
          $('.product-button').removeClass('is-hide');
          $('body').addClass('is-popup');
        });

      $('.close-product-filter')
        .once('filter-toggle')
        .on('click', function closeFilterClick() {
          $('.close-product-filter').addClass('is-hide');
          $('.show-product-filter').removeClass('is-hide');
          $('.modal').addClass('is-hide');
          $('body').removeClass('is-popup');
        });

      $('.product-button')
        .once('filter-toggle')
        .on('click', function closeFilterClick() {
          $('.product-button').addClass('is-hide');
          $('.modal').addClass('is-hide');
          $('.close-product-filter').addClass('is-hide');
          $('.show-product-filter').removeClass('is-hide');
          $('body').removeClass('is-popup');
        });
    },
  };
})(jQuery);